<template>
  <div class="voucher-editor">
    <content-tabs v-model="activeTab"></content-tabs>
    <div v-show="activeTab.name === 'เนื้อหา'">
      <div class="row">
        <div class="content-body col-9 p-0">
          <el-input
            type="text"
            class="input mb-3"
            :value="title"
            maxlength="80"
            placeholder="หัวข้อ"
            @input="handleChangeInput('title', $event)"
            show-word-limit
          ></el-input>
          <div ref="editor" class="editor"></div>
        </div>
        <div class="content-meta col-3">
          <content-meta
            v-model="value"
            :imageUrl="imageUrl"
            :thumbnail="thumbnail"
            @selectedImage="handleSelectImage($event)"
            @selectedThumbnail="handleSelectThumbnail($event)"
            @selectedPdf="handleSelectPdf($event)"
            @selectedLocation="handleSelectLocation($event)"
            @selectedImageAlbum="handleSelectImageAlbum($event)"
          ></content-meta>
        </div>
      </div>
    </div>
    <div v-show="activeTab.name === 'รายละเอียดกิจกรรม'">
      <content-event
        v-model="value.event"
        :eventConditions="eventConditions"
        @setEvent="handleSetEvent"
        @setEventConditions="handleSetEventConditions($event)"
      ></content-event>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ContentTabs from "./ContentTabs";
import ContentMeta from "./ContentMeta";
import ContentEvent from "./ContentEvent";
import { isEmpty } from "ramda";
import Quill from "quill";
import "quill/dist/quill.snow.css";

export default {
  props: ["value", "contentBodyJson", "imageUrl", "thumbnail", "eventConditions"],
  components: {
    ScButton,
    ContentTabs,
    ContentMeta,
    ContentEvent,
    "el-input": Input
  },
  data() {
    return {
      activeTab: { name: "เนื้อหา" },
      contentJson: null,
      contentHtml: "",
      editor: null
    }
  },
  watch: {
    contentBodyJson(value) {
      if (!this.contentJson) {
        this.contentJson = value;
        this.editor.setContents(this.contentJson);
        this.getEditorContent();
        this.setContent();
      }
    }
  },
  mounted() {
    const container = this.$refs.editor;
    this.editor = new Quill(container, {
      theme: "snow",
      formats: ["header", "bold", "underline", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote"]
        ],
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => false
            }
          }
        },
        clipboard: {
          matchVisual: false
        }
      },
      placeholder: "เริ่มพิมพ์ที่นี่"
    });

    this.editor.on("text-change", () => {
      this.getEditorContent();
      this.setContent();
    });
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupContent();
    },
    setupContent() {
      if (!isEmpty(this.content)) {
        this.editor.setContents(this.content);
      }
    },
    setContent() {
      this.$emit("setContent", {
        contentJson: this.contentJson,
        contentHtml: this.contentHtml
      });
    },
    getEditorContent() {
      this.contentJson = this.editor.getContents();
      this.contentHtml = this.editor.container.firstChild.innerHTML;
    },
    handleChangeInput(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },
    handleSelectImage(value) {
      this.$emit("input", { ...this.value, imageFile: value.imageFile });
    },
    handleSelectThumbnail(value) {
      this.$emit("input", { ...this.value, thumbnailFile: value.thumbnailFile });
    },
    handleSelectPdf(value) {
      this.$emit("input", { ...this.value, fileName: value.name, pdfFile: value });
    },
    handleSelectLocation(value) {
      this.$emit("input", {
        ...this.value,
        locationName: value.name,
        latitude: value.latitude,
        longitude: value.longitude
      });
    },
    handleSelectImageAlbum(value) {
      this.$emit("input", { ...this.value, voucherAlbum: value })
    },
    handleSetEvent(value) {
      this.$emit("input", { ...this.value, event: value })
    },
    handleSetEventConditions(value) {
      this.$emit("setEventConditions", value)
    }
  },
  computed: {
    title() {
      return this.value.title;
    },
    content() {
      return this.value.content;
    }
  }
}
</script>

<style scoped lang="scss">
.voucher-editor {
  .row {
    margin-left: 0px;
  }
}

.editor {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
</style>


// WEBPACK FOOTER //
// src/features/ruejai-club/modules/voucher-package/components/VoucherEditor.vue